import {ProductRole} from './../types';
import {EdgeRole, LakeRole, SearchRole, StreamRole} from './productRolesV1';
import {DisplayRole, OrgRole} from './rolesV2';

export const allRoles: string[] = [...Object.values(OrgRole), ...Object.values(DisplayRole)];
export const orgRoles: string[] = [OrgRole.OWNER, OrgRole.ADMIN, OrgRole.USER];
// ******** The hierarchy relies on the orders, do not change unless the hierarchy changes ********
export const orgRolesMap = {
  [OrgRole.OWNER]: [/.*cribl(?:[-\s]?organization)?[-\s]?owner.*/i],
  [OrgRole.ADMIN]: [/.*cribl(?:[-\s]?organization)?[-\s]?admin.*/i],
  [OrgRole.IAM_ADMIN]: [/.*cribl(?:[-\s]?organization)?[-\s]?iam[-\s]?admin.*/i],
  [OrgRole.BILLING_READER]: [/.*cribl(?:[-\s]?organization)?[-\s]?billing[-\s]?reader.*/i],
  [OrgRole.USER]: [/.*cribl(?:[-\s]?organization)?[-\s]?user.*/i],
};
export const streamRolesMap = {
  [StreamRole.ADMIN]: [/.*cribl[-\s]?stream[-\s]?admin/i],
  [StreamRole.EDITOR]: [/.*cribl[-\s]?stream[-\s]?editor/i],
  [StreamRole.READER]: [/.*cribl[-\s]?stream[-\s]?reader/i],
  [StreamRole.USER]: [/.*cribl[-\s]?stream[-\s]?user/i],
  [StreamRole.NOACCESS]: [/.*cribl[-\s]?stream[-\s]?noaccess/i], // Regex doesn't matter, putting here to make hierarchy work
};
export const edgeRolesMap = {
  [EdgeRole.ADMIN]: [/.*cribl[-\s]?edge[-\s]?admin/i],
  [EdgeRole.EDITOR]: [/.*cribl[-\s]?edge[-\s]?editor/i],
  [EdgeRole.READER]: [/.*cribl[-\s]?edge[-\s]?reader/i],
  [EdgeRole.USER]: [/.*cribl[-\s]?edge[-\s]?user/i],
  [EdgeRole.NOACCESS]: [/.*cribl[-\s]?edge[-\s]?noaccess/i], // Regex doesn't matter, putting here to make hierarchy work
};
export const searchRolesMap = {
  [SearchRole.ADMIN]: [/.*cribl[-\s]?search[-\s]?admin/i],
  [SearchRole.EDITOR]: [/.*cribl[-\s]?search[-\s]?editor/i],
  [SearchRole.USER]: [/.*cribl[-\s]?search[-\s]?user/i],
  [SearchRole.NOACCESS]: [/.*cribl[-\s]?search[-\s]?noaccess/i], // Regex doesn't matter, putting here to make hierarchy work
};
export const lakeRolesMap = {
  [LakeRole.ADMIN]: [/.*cribl[-\s]?lake[-\s]?admin/i],
  [LakeRole.EDITOR]: [/.*cribl[-\s]?lake[-\s]?editor/i],
  [LakeRole.READER]: [/.*cribl[-\s]?lake[-\s]?reader/i],
  [LakeRole.NOACCESS]: [/.*cribl[-\s]?lake[-\s]?noaccess/i], // Regex doesn't matter, putting here to make hierarchy work
};

export const ProductRoles = [
  ...Object.values(EdgeRole),
  ...Object.values(SearchRole),
  ...Object.values(StreamRole),
  ...Object.values(LakeRole),
];

export const validProductRoles = [
  ...Object.values(EdgeRole),
  ...Object.values(SearchRole),
  ...Object.values(StreamRole),
  ...Object.values(LakeRole),
] as ProductRole[];

export enum WorkspaceVersion {
  V1 = 1,
  V2 = 2,
}
